import * as React from 'react';
import { useContext } from 'react';
import NewsListingsModuleProps from './type';
import PageHeader from '../../components/PageHeader';
import NewsList from '../../components/NewsList';
import LocalizationContext from '../../contexts/Localizations';

import './styles.scss';

const NewsListingsModule = ({
  header,
  newsList,
  isTagPage,
}: NewsListingsModuleProps) => {
  const { translations } = useContext(LocalizationContext);
  const root = 'news-listing-module';
  const classes = [
    'page-template',
    root,
  ];

  if (isTagPage) {
    classes.push(`${root}--tag-page`);
  }

  return (
    <section className={classes.join(' ')}>
      {header && (
        <PageHeader {...header} />
      )}
      {newsList && (
        <NewsList
          {...newsList}
          title={translations.news.latest}
          noResultsText={translations.news.noResultsText}
        />
      )}
    </section>
  );
};

export default NewsListingsModule;
